import React, { useEffect } from 'react'
import PageLoader from '../../shared/PageLoader'
import { useAppDispatch, useAppSelector } from '../../../redux/hook';
import { getAllCompaniesDetails, getAssociateCompanies, getLocations } from '../../../redux/features/inputModule.slice';
import { Box, Button, Checkbox, Drawer, FormControl, FormControlLabel, FormLabel, IconButton, InputAdornment, InputLabel, MenuItem, Modal, OutlinedInput, Radio, RadioGroup, Select, Table, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow, TableSortLabel, TextField, Typography } from '@mui/material';
import { FaUpload, FaDownload } from "react-icons/fa";
import { IoMdAdd, IoMdClose, IoMdSearch } from "react-icons/io";
import { DEFAULT_OPTIONS_PAYLOAD, DEFAULT_PAYLOAD } from '../../common/Table';
import { addHoliday, deleteHoliday, editHoliday, getHolidaysList, resetAddHolidayDetails, resetBulkDeleteHolidaysDetails, resetDeleteHolidayDetails, resetEditHolidayDetails, resetUploadHolidayDetails, uploadHoliday } from '../../../redux/features/holidayList.slice';
import Icon from '../../common/Icon';
import { useExportEmployees, useExportEmployeesLeaveAvailed, useExportHolidayList } from '../../../backend/exports';
import { download, downloadFileContent, preventDefault } from '../../../utils/common';
import { ERROR_MESSAGES } from '../../../utils/constants';
import { toast } from 'react-toastify';
import { Alert } from 'react-bootstrap';
import { bulkDeleteLeaveAvailed, getEmployees, getEmployeesAttendance, getEmployeesLeaveAvailed, getEmployeesLeaveCredit } from '../../../redux/features/employeeMaster.slice';
import { initial } from 'underscore';
import { getBasePath } from '../../../App';
import { navigate, useQueryParams } from 'raviger';
import { hasUserAccess } from '../../../backend/auth';
import { USER_PRIVILEGES } from '../UserManagement/Roles/RoleConfiguration';

const style = {
  position: 'absolute' as 'absolute',
  top: '25%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 600,
  bgcolor: 'background.paper',
  boxShadow: 24,
};

const EmployeeLeaveAvailedUpload = () => {

  const dispatch = useAppDispatch();

  const employeesLeaveAvailedDetails = useAppSelector((state) => state.employeeMaster.employeesLeaveAvailedDetails)

  console.log('empleavevavailed', employeesLeaveAvailedDetails);

  const companiesDetails = useAppSelector((state) => state.inputModule.companiesDetails);
  const associateCompaniesDetails = useAppSelector((state) => state.inputModule.associateCompaniesDetails);
  const locationsDetails = useAppSelector((state) => state.inputModule.locationsDetails);
  const bulkDeleteEmployeeAvailedDetails = useAppSelector((state) => state.employeeMaster.bulkDeleteLeaveAvailed)

  const uploadLeaveAvailedDetails = useAppSelector((state) => state.holidayList.uploadHolidayDetails)

  const { exportRecords, exporting } = useExportEmployeesLeaveAvailed((response: any) => {
    let filename = associate_company_name+'_'+locationName+'_'+'Employee-LeaveAvailed'+ '_'+year+'_'+month+ '.xlsx';

    downloadFileContent({
      name: filename,
      type: response.headers['content-type'],
      content: response.data
    });
  }, () => {
    toast.error(ERROR_MESSAGES.DEFAULT);
  });

  const employeesLeaveAvailed = employeesLeaveAvailedDetails.data.items || []
  const employeesLeaveAvailedCount = employeesLeaveAvailedDetails.data.meta.total_count
  console.log("employeesLeaveAvailed", employeesLeaveAvailed, 'employeesLeaveAvailedCount', employeesLeaveAvailedCount)

  const companies = companiesDetails.data.items || []
  const associateCompanies = associateCompaniesDetails.data.items || []
  const locations = locationsDetails.data.items || []

  const loading = exporting || bulkDeleteEmployeeAvailedDetails.status === 'loading' || uploadLeaveAvailedDetails.status === 'loading' || employeesLeaveAvailedDetails.status === 'loading' || companiesDetails.status === 'loading' || associateCompaniesDetails.status === 'loading' || locationsDetails.status === 'loading'
  const [query] = useQueryParams();
  const [company, setCompany] = React.useState(query.company ? query.company : '');
  const [associate_company, setAssociateCompany] = React.useState(query.associate_company ? query.associate_company : '');
  const [location, setLocation] = React.useState((query.location && query.stateName) ? (query.location + '^' + query.stateName) : '');
  const [year, setYear] = React.useState(query.year ? query.year : '');
  const [month, setMonth] = React.useState(query.month ? query.month : '');

  const [searchInput, setSearchInput] = React.useState('');
  const [activeSort, setActiveSort] = React.useState('code')
  const [sortType, setSortType] = React.useState<any>('asc')

  const [uploadError, setUploadError] = React.useState(false);
  const [openUploadModal, setOpenUploadModal] = React.useState(false);

  const [rowsPerPage, setRowsPerPage] = React.useState(10)
  const [page, setPage] = React.useState(0);
  const [payload,setPayload] = React.useState({
    filters: {
      employee_code_cont: searchInput
    },
    per: rowsPerPage,
    page: page+1,
    sorts: [`employee_code asc`],
    "includeCentral": true
  });

  const [selectedAvailed, setSelectedAvailed] = React.useState<any>([]);
  const [openBulkDeleteModal, setOpenBulkDeleteModal] = React.useState(false);

  const [companyName, setCompanyName] = React.useState('');
  const [associate_company_name, setAssociateCompanyName] = React.useState('');
  const [locationName, setLocationName] = React.useState('');
 
  const updateFilters = (new_filters: any) => {
    payload.filters = {
      ...payload.filters, ...new_filters
    }
    setPayload((prev) => ({
      ...prev, 
      ...payload 
    }));
  }

  const updateSort = (new_sorts: any) => {
    payload.sorts = new_sorts;
    setPayload((prev) => ({
      ...prev, 
      ...payload 
    }));
  }
  
  const updatePagination = (pagination: any) => {
    payload.page = pagination.page;
    payload.per  = pagination.per;
    setPayload((prev) => ({
      ...prev, 
      ...payload 
    }));
  }
 
  const getCompanyNameById = (id: string, companies: { id: string; name: string; }[]) => {
    for (let i = 0; i < companies.length; i++) {
      if (companies[i].id === id) {
        return companies[i].name;
      }
    }
    return '';
  };

  const getAssocCompanyNameById = (id: string, associateCompanies: { id: string; name: string; }[]) => {
    for (let i = 0; i < associateCompanies.length; i++) {
      if (associateCompanies[i].id === id) {
        return associateCompanies[i].name;
      }
    }
    return '';
  };

  const getLocationById = (id: string, locations: any[]) => {
    for (let i = 0; i < locations.length; i++) {
      if (locations[i].location_id === id) {
        return locations[i].location.name;
      }
    }
    return '';
  };

  const handleChangeCompany = (event: any) => {
    setAssociateCompany(''); setLocation(''); setYear(''); setMonth(''); setCompany(event.target.value);

    const selectedCompanyId = event.target.value as string;
    const selectedCompanyName = getCompanyNameById(selectedCompanyId, companies);
    setCompanyName(selectedCompanyName);
    updateFilters({
      company_id_eq: event.target.value
    })
    dispatch(getEmployeesLeaveAvailed(payload))
  };

  const handleChangeAssociateCompany = (event: any) => {
    const selectedCompanyId = event.target.value as string;
    const selectedCompanyName = getAssocCompanyNameById(selectedCompanyId, associateCompanies);
    setAssociateCompanyName(selectedCompanyName);
    setLocation('')
    setYear('')
    setMonth('')
    setAssociateCompany(event.target.value);
    updateFilters({
      associate_company_id_eq: event.target.value
    })
    dispatch(getEmployeesLeaveAvailed(payload))
  };

  const handleChangeLocation = (event: any) => {
    const selectedCompanyId =  event.target.value.split('^')[0] as string;
    // alert(event.target.value);
    const selectedCompanyName = getLocationById(selectedCompanyId, locations);
    setLocationName(selectedCompanyName);
    setYear('')
    setMonth('')
    setLocation(event.target.value);
    updateFilters({
      location_id_eq: event.target.value.split('^')[0]
    })
    dispatch(getEmployeesLeaveAvailed(payload))
  };

  const handleChangeYear = (event: any) => {
    setYear('')
    setYear(event.target.value.toString());
    updateFilters({
      year_eq: event.target.value.toString()
    })
    dispatch(getEmployeesLeaveAvailed(payload))
  };

  const handleChangeMonth = (event: any) => {
    setMonth(event.target.value);
    updateFilters({
      month_eq: event.target.value
    })
    dispatch(getEmployeesLeaveAvailed(payload))
  };

  const handleChangeSearchInput = (event: any) => {
    setSearchInput(event.target.value)
    updateFilters({
      employee_code_cont: event.target.value
    })
  }

  useEffect(() => {
    dispatch(getEmployeesLeaveAvailed(payload))
    const companiesPayload: any = { ...DEFAULT_OPTIONS_PAYLOAD, filters: { is_parent_eq: true } }
    dispatch(getAllCompaniesDetails(companiesPayload))
  }, [])

  useEffect(() => {
    const payload: any = { 
      ...DEFAULT_OPTIONS_PAYLOAD, 
      filters: { 
        is_parent_eq: false, 
        parent_company_id_eq: company 
      } 
    }
    if (company) {
      dispatch(getAssociateCompanies(payload))
    }
  }, [company])

  useEffect(() => {
    const payload: any = {
      ...DEFAULT_OPTIONS_PAYLOAD, filters: { 
        company_id_eq: associate_company 
      },
      includes: {
        location: { city: ['state'] }
      },
      include: {
        location: {
          only: ['id','name','code'],
          include: {
            city: {
              only: ['id','name','code'],
              include: {
                state: {
                  only: ['id','name','code']
                }
              }
            }
          }
        }
      },
      sorts: [`location_name asc`]
    }
    if (associate_company) {
      dispatch(getLocations(payload))
    }
  }, [associate_company])

  useEffect(() => {
    if (employeesLeaveAvailedDetails.status === 'succeeded') {

    } else if (employeesLeaveAvailedDetails.status === 'failed') {
      toast.error(ERROR_MESSAGES.DEFAULT);
    }
  }, [employeesLeaveAvailedDetails.status])

  useEffect(() => {
    if (query.company && query.associate_company && query.location && query.stateName && query.year && query.month) {
      const payload = {
        filters: {
          company_id_eq: query.company,
          associate_company_id_eq: query.associate_company,
          location_id_eq: query.location.split('^')[0],
          year_eq: query.year,
          month_eq: query.month,
          employee_code_cont: searchInput
        },
        per: 10,
        page: 1,
        sorts: [`code asc`],
        "includeCentral": true
      }
      dispatch(getEmployees(payload))
    }
  }, [])

  const yearsList = []
  const currentYear = new Date().getFullYear();

  for (let i = currentYear; i >= 1950; i--) {
    yearsList.push(i)
  }

  const monthList = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  const onClickSearch = () => {
    dispatch(getEmployeesLeaveAvailed(payload))
  }

  const onClickClearSearch = () => {
    setSearchInput('')
    updateFilters({
      employee_code_cont: ""
    })
    dispatch(getEmployeesLeaveAvailed(payload))
  }

  const onClickSortCode = () => {
    let type = 'asc'
    setActiveSort('employee_code');
    if (sortType === 'asc') {
      setSortType('desc')
      type = 'desc'
    } else {
      setSortType('asc')
    }
    updateSort([`employee_code ${type}`])
    dispatch(getEmployeesLeaveAvailed(payload))
  }

  const onClickSortName = () => {
    let type = 'asc'
    setActiveSort('employee_name');
    if (sortType === 'asc') {
      setSortType('desc')
      type = 'desc'
    } else {
      setSortType('asc')
    }
    updateSort([`employee_name ${type}`])
    dispatch(getEmployeesLeaveAvailed(payload))
  }

  const onClickSortNoOfDays = () => {
    let type = 'asc'
    setActiveSort('no_of_days');
    if (sortType === 'asc') {
      setSortType('desc')
      type = 'desc'
    } else {
      setSortType('asc')
    }
    updateSort([`no_of_days ${type}`])
    dispatch(getEmployeesLeaveAvailed(payload))
  }

  const onClickSortStartDate = () => {
    let type = 'asc'
    setActiveSort('leave_start_date');
    if (sortType === 'asc') {
      setSortType('desc')
      type = 'desc'
    } else {
      setSortType('asc')
    }
    updateSort([`leave_start_date ${type}`])
    dispatch(getEmployeesLeaveAvailed(payload))
  }

  const onClickSortEndDate = () => {
    let type = 'asc'
    setActiveSort('leave_end_date');
    if (sortType === 'asc') {
      setSortType('desc')
      type = 'desc'
    } else {
      setSortType('asc')
    }
    updateSort([`leave_end_date ${type}`])
    dispatch(getEmployeesLeaveAvailed(payload))
  }

  const handleChangePage = (event: unknown, newPage: number) => {
    updatePagination({
      per: rowsPerPage,
      page: newPage + 1,
    })
    dispatch(getEmployeesLeaveAvailed(payload))
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement>) => {
    updatePagination({
      per: parseInt(event.target.value, 10),
      page: 1,
    })
    dispatch(getEmployeesLeaveAvailed(payload))
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const onClickAllCheckBox = () => {
    if (selectedAvailed.length !== employeesLeaveAvailed.length) {
      const allIds = employeesLeaveAvailed && employeesLeaveAvailed.map((each: any) => each.id)
      setSelectedAvailed(allIds)
    } else {
      setSelectedAvailed([])
    }
  }

  const onClickIndividualCheckBox = (id: any) => {
    if (selectedAvailed.includes(id)) {
      const updatedSelectedAvailed: any = selectedAvailed.filter((each: any) => each != id)
      setSelectedAvailed(updatedSelectedAvailed)
    } else {
      setSelectedAvailed([...selectedAvailed, id])
    }
  }

  const onClickBulkDelete = () => {
    setOpenBulkDeleteModal(true)
  }
  const onClickConfirmBulkDelete = () => {
    dispatch(bulkDeleteLeaveAvailed(selectedAvailed))
    let type = 'asc'
    setActiveSort('restricted');
    if (sortType === 'asc') {
      setSortType('desc')
      type = 'desc'
    } else {
      setSortType('asc')
    }
    setCompany('')
    setAssociateCompany('')
    setLocation('')
    setYear('')
    setMonth('')

    const EmployeePayload: any = {
      filters: {employee_code_cont: searchInput},
      per: rowsPerPage,
      page: page + 1,
      sorts: [`name ${type}`],
      "includeCentral": true
    }
    dispatch(getEmployees(EmployeePayload))
  }

  useEffect(() => {
    if (bulkDeleteEmployeeAvailedDetails.status === 'succeeded') {
      toast.success(`Leave Availed successfully.`)
      setSelectedAvailed([])
      dispatch(resetBulkDeleteHolidaysDetails())
      setOpenBulkDeleteModal(false)
      const EmployeeDefaultPayload: any = {
        search: "",
        filters: {},
        per: 10,
        page: 1,
        sorts: [`name asc`],
        "includeCentral": true
      }
      dispatch(getHolidaysList(EmployeeDefaultPayload))
    } else if (bulkDeleteEmployeeAvailedDetails.status === 'failed') {
      toast.error(ERROR_MESSAGES.DEFAULT);
    }
  }, [bulkDeleteEmployeeAvailedDetails.status])

  const onClickBackToDashboard = () => {
    navigate(`${getBasePath()}/inputUploads/dashboard`);
  }

  useEffect(() => {
    if (uploadLeaveAvailedDetails.status === 'succeeded') {
      if (uploadLeaveAvailedDetails.data.size === 0) {
        toast.success(`Uploaded successfully.`)
        dispatch(resetUploadHolidayDetails())
        setOpenUploadModal(false)
        setUploadError(false)
        const leaveDefaultPayload: any = {
          search: "",
          filters: {},
          per: 10,
          page: 1,
          sorts: [`name asc`],
          "includeCentral": true
        }
        dispatch(getHolidaysList(leaveDefaultPayload))
      } else {
        setUploadError(true)
      }
    } else if (uploadLeaveAvailedDetails.status === 'failed') {
      toast.error(ERROR_MESSAGES.DEFAULT);
    }
  }, [uploadLeaveAvailedDetails])

  const onclickExport = () => {
    const employeesLeavePayload: any = {
      filters: {...getFilters(), employee_code_cont: searchInput},
      sorts: [`employee_code asc`],
      "includeCentral": true
    }
    exportRecords({ ...employeesLeavePayload });
  }

  console.log('empleavevailed',employeesLeaveAvailed);

  
  const formatDate = (dateString: string | number | Date) => {
    if (!dateString) return '-';
    const options: Intl.DateTimeFormatOptions = { day: '2-digit', month: '2-digit', year: 'numeric' };
    return new Date(dateString).toLocaleDateString('en-GB', options); // 'en-GB' for DD-MM-YYYY format
  };

  function getFilters() {
    const filters: any = {}
    if(company){
      filters.company_id_eq = company;          ;
    }
    if(associate_company){
      filters.associate_company_id_eq = associate_company;
    }
    if(location){
      filters.location_id_eq = location.split('^')[0];
    }
    if(year){
      filters.year_eq = year
    }
    if(month){
      filters.month_eq = month
    }
    return filters;
  }
  

  return (
    <div style={{ height: '100vh', backgroundColor: '#ffffff' }}>
      <Modal
        open={openBulkDeleteModal}
        onClose={() => setOpenBulkDeleteModal(false)}
      >
        <Box sx={style}>
          <Box sx={{ backgroundColor: '#E2E3F8', padding: '10px', px: '20px', borderRadius: '6px', boxShadow: '0px 6px 10px #CDD2D9', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <Typography sx={{ font: 'normal normal normal 32px/40px Calibri' }}>Delete Employees</Typography>
            <IconButton
              onClick={() => setOpenBulkDeleteModal(false)}
            >
              <IoMdClose />
            </IconButton>
          </Box>
          <Box sx={{ padding: '20px', backgroundColor: '#ffffff' }}>
            <Box>
              <Typography variant='h5'>There are {selectedAvailed.length} record(s) selected for deleting.</Typography>
              <Typography mt={2}>Are you sure you want to delete all of them ?</Typography>
            </Box>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mt: 2 }}>
              <Button variant='outlined' color="error" onClick={() => setOpenBulkDeleteModal(false)}>No</Button>
              <Button variant='contained' onClick={onClickConfirmBulkDelete}>Yes</Button>
            </Box>
          </Box>
        </Box>
      </Modal>

      {loading ? <PageLoader>Loading...</PageLoader> :

        <div>
          <Box sx={{ paddingX: '20px', paddingY: '10px', }}>
            <div style={{ backgroundColor: '#E2E3F8', padding: '20px', borderRadius: '6px', boxShadow: '0px 6px 10px #CDD2D9' }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '15px', marginTop: '10px' }}>
                <h5 style={{ font: 'normal normal normal 32px/40px Calibri' }}>Employee Leave Availed</h5>
                <div style={{ marginRight: '12px', display: 'flex', alignItems: 'center', width: '200px', justifyContent: 'space-between' }}>
                  {/* <Button onClick={onClickBackToDashboard} variant='contained'> Back To Dashboard</Button> */}
                  {
                  //   hasUserAccess(USER_PRIVILEGES.DELETE_EMPLOYEE_LEAVE_CREDIT) &&
                  // <Button onClick={onClickBulkDelete} variant='contained' color='error' disabled={selectedAvailed && selectedAvailed.length === 0}> Bulk Delete</Button>
                  }
                  {/* <Button onClick={onClickBulkDelete} variant='contained' color='error' disabled={selectedAvailed && selectedAvailed.length === 0}> Bulk Delete</Button> */}
                  <button onClick={onclickExport} disabled={!company || !associate_company} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', backgroundColor: !company || !associate_company? '#707070' : '#ffffff', color: !company || !associate_company? '#ffffff': '#000000', border:'1px solid #000000', width:'40px', height:'30px', borderRadius:'8px'}}> <FaDownload /> </button>
                </div>
              </div>
              <div style={{ display: 'flex' }}>

                <Box sx={{ mr: 1 }}>
                  <Typography mb={1}>Company</Typography>
                  <FormControl sx={{ width: '100%', maxWidth: '200px', backgroundColor: '#ffffff', borderRadius: '5px' }} size="small">
                    <Select
                      sx={{ '.MuiOutlinedInput-notchedOutline': { border: 0 } }}
                      value={company}
                      displayEmpty
                      onChange={handleChangeCompany}
                      MenuProps={{
                        PaperProps: {
                          sx: {
                            maxHeight: 200,
                            width: 230,
                            // marginLeft: "21px", 
                            marginTop: "3px"
                          }
                        }
                      }}
                    >
                      <MenuItem disabled sx={{ display: 'none' }} value="">
                        Select Company
                      </MenuItem>
                      {companies && companies.map((each: any) => {
                        return <MenuItem sx={{ width: '240px', whiteSpace: 'initial' }} value={each.id}>{each.name}</MenuItem>
                      })}
                    </Select>
                  </FormControl>
                </Box>

                <Box sx={{ mr: 1 }}>
                  <Typography mb={1}>Associate Company</Typography>
                  <FormControl sx={{ width: '100%', maxWidth: '200px', backgroundColor: '#ffffff', borderRadius: '5px' }} size="small">
                    <Select
                      sx={{ '.MuiOutlinedInput-notchedOutline': { border: 0 } }}
                      displayEmpty
                      value={associate_company}
                      disabled={!company}
                      onChange={handleChangeAssociateCompany}
                      MenuProps={{
                        PaperProps: {
                          sx: {
                            maxHeight: 200,
                            width: 230,
                            // marginLeft: "27px",
                            marginTop: "3px"
                          }
                        }
                      }}
                    >
                      <MenuItem disabled sx={{ display: 'none' }} value="">
                        Select Associate Company
                      </MenuItem>
                      {associateCompanies && associateCompanies.map((each: any) => {
                        return <MenuItem sx={{ width: '240px', whiteSpace: 'initial' }} value={each.id}>{each.name}</MenuItem>
                      })}
                    </Select>
                  </FormControl>
                </Box>

                <Box sx={{ mr: 1 }}>
                  <Typography mb={1}>Location</Typography>
                  <FormControl sx={{ width: '100%', maxWidth: '200px', backgroundColor: '#ffffff', borderRadius: '5px' }} size="small">
                    <Select
                      sx={{ '.MuiOutlinedInput-notchedOutline': { border: 0 } }}
                      displayEmpty
                      value={location}
                      disabled={!associate_company}
                      onChange={handleChangeLocation}
                      MenuProps={{
                        PaperProps: {
                          sx: {
                            maxHeight: 200,
                            width: 230,
                            marginLeft: "27px",
                            marginTop: "3px"
                          }
                        }
                      }}
                    >
                      <MenuItem disabled sx={{ display: 'none' }} value="">
                        Select Location
                      </MenuItem>
                      {locations && locations.map((each: any) => {
                        const { id, name, code, city }: any = each.location || {};
                        const { state } = city || {};
                        return <MenuItem value={each.location_id + '^' + state.id}>{`${name} (${state.code}-${city.code}-${code})`}</MenuItem>
                      })}
                    </Select>
                  </FormControl>
                </Box>

                <Box sx={{ mr: 1 }}>
                  <Typography mb={1}>Year</Typography>
                  <FormControl sx={{ width: '100%', maxWidth: '200px', backgroundColor: '#ffffff', borderRadius: '5px' }} size="small">
                    <Select
                      sx={{ '.MuiOutlinedInput-notchedOutline': { border: 0 } }}
                      displayEmpty
                      value={year}
                      disabled={!location}
                      onChange={handleChangeYear}
                      MenuProps={{
                        PaperProps: {
                          sx: {
                            maxHeight: 200,
                            width: 100,
                            // marginLeft: "21px", 
                            marginTop: "3px"
                          }
                        }
                      }}
                    >
                      <MenuItem disabled sx={{ display: 'none' }} value="">
                        Select Year
                      </MenuItem>
                      {yearsList && yearsList.map((each: any) =>
                        <MenuItem value={each}>{each}</MenuItem>
                      )}
                    </Select>
                  </FormControl>
                </Box>

                <Box sx={{ mr: 1 }}>
                  <Typography mb={1}>Month</Typography>
                  <FormControl sx={{ width: '100%', maxWidth: '200px', backgroundColor: '#ffffff', borderRadius: '5px' }} size="small">
                    <Select
                      sx={{ '.MuiOutlinedInput-notchedOutline': { border: 0 } }}
                      displayEmpty
                      value={month}
                      disabled={!year}
                      onChange={handleChangeMonth}
                      MenuProps={{
                        PaperProps: {
                          sx: {
                            maxHeight: 200,
                            width: 100,
                            // marginLeft: "21px", 
                            marginTop: "3px"
                          }
                        }
                      }}
                    >
                      <MenuItem disabled sx={{ display: 'none' }} value="">
                        Select Month
                      </MenuItem>
                      {monthList && monthList.map((each: any) =>
                        <MenuItem value={each}>{each}</MenuItem>
                      )}
                    </Select>
                  </FormControl>
                </Box>

                <Box sx={{ mr: 1 }}>
                  <Typography mb={1}>Search (Emp Code)</Typography>
                  <FormControl sx={{ width: '100%', maxWidth: '200px', backgroundColor: '#ffffff', borderRadius: '5px' }} size="small">
                    <InputLabel htmlFor="outlined-adornment-search">Search</InputLabel>
                    <OutlinedInput
                      value={searchInput}
                      onChange={handleChangeSearchInput}
                      sx={{ '.MuiOutlinedInput-notchedOutline': { border: 0 } }}
                      id="outlined-adornment-search"
                      type='text'

                      endAdornment={
                        <InputAdornment position="end">
                          {searchInput &&
                            <IconButton
                              onClick={onClickClearSearch}
                              edge="end"
                            >
                              <IoMdClose />
                            </IconButton>
                          }
                          <IconButton
                            onClick={onClickSearch}
                            edge="end"
                          >
                            <IoMdSearch />
                          </IconButton>
                        </InputAdornment>
                      }
                      label="Search"
                    />
                  </FormControl>
                </Box>

              </div>
            </div>
          </Box>

          <Box sx={{ paddingX: '20px' }}>
            {
              employeesLeaveAvailed && employeesLeaveAvailed.length <= 0 ?

                <Box sx={{ height: '60vh', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                  <Typography variant='h5'>No Records Found</Typography>
                </Box>
                :
                <>
                  <TableContainer sx={{ border: '1px solid #e6e6e6', marginTop: '10px', maxHeight: '380px', overflowY: 'scroll' }}>
                    <Table stickyHeader sx={{ minWidth: 650 }} aria-label="sticky table">
                      <TableHead sx={{ '.MuiTableCell-root': { backgroundColor: '#E7EEF7' ,fontWeight:'600'} }}>
                        <TableRow>
                          <TableCell><Checkbox checked={(selectedAvailed && selectedAvailed.length) === (employeesLeaveAvailed && employeesLeaveAvailed.length)} onClick={onClickAllCheckBox} /></TableCell>
                          <TableCell > <TableSortLabel active={activeSort === 'employee_code'} direction={sortType} onClick={onClickSortCode}>Employee Code</TableSortLabel></TableCell>
                         
                          <TableCell > <TableSortLabel active={activeSort === 'no_of_days'} direction={sortType} onClick={onClickSortNoOfDays}>Number Of Days</TableSortLabel></TableCell>
                          <TableCell > <TableSortLabel >Leave Type</TableSortLabel></TableCell>
                          <TableCell > <TableSortLabel >Start Date</TableSortLabel></TableCell>
                          <TableCell > <TableSortLabel >End Date</TableSortLabel></TableCell>
                          <TableCell > <TableSortLabel >Half Day TakenDate</TableSortLabel></TableCell>
                      
                          {/* <TableCell > Actions</TableCell> */}
                        </TableRow>
                      </TableHead>

                      <TableBody>
                        {employeesLeaveAvailed && employeesLeaveAvailed.map((each: any, index: number) => (
                          <TableRow
                            key={each._id}
                            sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                          >
                            <TableCell><Checkbox checked={selectedAvailed.includes(each.id)} onClick={() => onClickIndividualCheckBox(each.id)} /></TableCell>

                            <TableCell >{each.employee_code}</TableCell>
                           
                            <TableCell >{each.no_of_days}</TableCell>
                            <TableCell >{each.leave_type}</TableCell>
                            <TableCell >{formatDate(each.leave_start_date)}</TableCell>
                            {/* <TableCell >{each.leave_start_date}</TableCell> */}
                            <TableCell >{formatDate(each.leave_end_date)}</TableCell>
                            <TableCell >{formatDate(each.half_day_leave_taken_date)}</TableCell>
                            {/* <TableCell >{each.leave_end_date}</TableCell> */}
                            {/* <TableCell >
                                        <Box sx={{display:'flex', justifyContent:'space-between', width:'100px'}}>
                                          <Icon action={() => onclickEdit(each)} style={{color:'#039BE5'}} type="button" name={'pencil'} text={'Edit'}/>
                                          <Icon action={() => onclickDelete(each)} style={{color:'#EB1010'}} type="button" name={'trash'} text={'Delete'}/>
                                          <Icon action={() => onclickView(each)}  style={{color:'#00C853'}} type="button" name={'eye'} text={'View'}/>
                                        </Box>
                                      </TableCell> */}
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                  <TablePagination
                    sx={{
                      '.MuiTablePagination-toolbar': {
                        backgroundColor: '#EFEBFE',
                        height: '30px',
                        display: 'flex',
                        justifyContent: 'flex-end'
                      },
                      '.MuiTablePagination-displayedRows': {
                        margin: '0',
                      },
                      '.MuiTablePagination-selectLabel': {
                        margin: '0',
                      },
                      '.MuiTablePagination-spacer': {
                        display: 'none '
                      },
                      '.MuiTablePagination-input': {
                        marginRight: 'auto'
                      },
                    }}

                    labelRowsPerPage='Show'
                    labelDisplayedRows={(page) =>
                      `Showing ${page.from}-${page.to === -1 ? page.count : page.to} of ${page.count}`
                    }
                    rowsPerPageOptions={[10, 25, 50, 100]}
                    component="div"
                    count={employeesLeaveAvailedCount}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                  />
                </>
            }
          </Box>
        </div>
      }
    </div>
  )
}

export default EmployeeLeaveAvailedUpload
